<template>
  <div class="bbp-select-tag">
    <v-select
      :options="options"
      multiple
      :searchable="false"
      :appendToBody="true"
      v-model="tags"
      @input="setTag"
      @open="open"
      @close="close"
      placeholder="set tag"
      label="name"
    >
      <template #selected-option-container="{option}">
        <div
          class="bbp-select-tag__selected bbp-select-tag__selected_background"
          :style="{ background: `rgba(${option.color}, 0.15)`}"
        >
          <span
            class="bbp-select-tag__text"
            :style="{color: `rgba(${option.color}, 1)`}"
          >
            {{ option.name }}
          </span>
          <i
            @click="deselect(option)"
            class="bbp-icon-cross bbp-select-tag__icon"
            :style="{color: `rgba(${option.color}, 1)`}"
          />
        </div>
      </template>
      <template #option="item">
        <span
          class="bbp-select-tag__select"
          :class="{'bbp-select-tag__select_selected': selectedTag(item)}"
          :style="{
            color: `rgba(${item.color}, 1)`,
            background: `rgba(${item.color}, 0.15)`
          }"
        >
          {{ item.name }}
        </span>
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'BBPSelectTag',
  props: ['options', 'values'],
  components: {
    vSelect
  },
  data () {
    return {
      tags: this.values || [],
      element: null
    }
  },
  methods: {
    setTag () {
      this.$emit('change', this.tags)
    },
    open () {
      const body = document.getElementsByTagName('body')
      const [element] = body
      this.element = element
      element.classList.add('dropdown-open')
    },
    close () {
      this.element.classList.remove('dropdown-open')
    },
    deselect ({_id, id}) {
      const ids = _id || id
      const index = this.tags.findIndex((el) => (el.id === ids) || (el._id === ids))
      this.tags.splice(index, 1)
    },
    selectedTag (tag) {
      return this.tags.some(item => (item.id === tag.id) || item._id === tag._id)
    }
  }
}
</script>

<style lang="scss">
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bbp-select-tag {
  @include global-font;

  &__select {
    color: $color-denim;
    background: rgba($color-accent, 0.2);
    padding: 3px 5px;
    border: none;
    border-radius: 4px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    display: inline-block;
    white-space: nowrap;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;

    &_selected {
      color: $color-silver;
      background: rgba($color-silver-chalice, 0.2);
    }
  }

  &__text {
    display: inline-block;
    white-space: nowrap;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__selected {
    display: flex;
    align-items: center;
    margin: 0 0 8px 8px;
    padding: 4px;
    border: none;
    border-radius: 4px;
    color: $color-denim;
    background: none;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;

    &_background {
      background: rgba($color-accent, 0.2);
    }
  }

  &__icon {
    cursor: pointer;
  }

  .vs__selected-options {
    padding-top: 8px;
  }

  .vs__search {
    position: absolute;
  }

}

.dropdown-open {
  @include global-font;

  .vs__dropdown-menu {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: flex-start;
    align-items: center;
    margin: 8px 0;
    padding-top: 10px;
    border-radius: 5px;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
  }

  .vs--open .vs__dropdown-toggle {
    border-color: $color-mercury;
  }

  .vs--open .vs__dropdown-toggle {
    border-bottom-color: $color-mercury;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .vs__dropdown-option {
    padding: 0 !important;
    margin: 0 0 8px 8px !important;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Main/InputFields/BBPSelectTag/BBPSelectTag.vue